import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import { BiTrash, BiUpload, BiChevronRight } from "react-icons/bi";
import { FcFolder, FcImageFile, FcDocument, FcFile } from "react-icons/fc";
import { Breadcrumb, Button, Modal } from "react-bootstrap";
import ErrorHandlingService from "../../../../core/service/ErrorHandlingService";
import DmsService from "../../../../core/service/DmsService";
import FolderCreate from "../FolderCreate/FolderCreate";

import Admin_folder from "../../../../images/Admin_folder.svg";
import New_Folder from "../../../../images/New_Folder.svg";
import Share_folder from "../../../../images/Share_folder.svg";

function Folder({ t, folder, callbackFolder, deleteFolder, callbackRename }) {
  const [showInfo, setShowInfo] = useState(false);
  const [show, setShow] = useState(false);
  const [showCheck, setShowCheck] = useState(false);
  const [deleteItem, setDeleteItem] = useState("");
  const [rename, setRename] = useState("");
  const [showRename, setShowRename] = useState(false);
  const handleClose = () => setShow(false);
  const handleRenameClose = () => setShowRename(false);
  const [showAllNew, setShowAllNew] = useState(false);

  //   document.addEventListener("contextmenu", (event) => {
  //     event.preventDefault();
  //   });
  useEffect(() => {
    document.addEventListener("click", handleClickOuter);
    return () => {
      document.removeEventListener("click", handleClickOuter);
    };
  });

  const handleClick = (e, id, folderName, regId) => {
    e.preventDefault();

    if (e.type === "contextmenu") {
      setShowInfo(!showInfo);
    } else if (e.type === "click") {
      setShowCheck(!showCheck);
      showInfo && setShowInfo(false);
    }
    if (e.detail === 2) {
      //doubleclick
      //   handleOpenFolder(id);
      callbackFolder(id, folderName, regId);
    }
  };
  const handleClickOuter = useCallback(() => setShowInfo(false), [showInfo]);
  const handleDelete = (e, item) => {
    e.preventDefault();
    setShow(true);
    setShowInfo(false);
    setDeleteItem(item);
  };
  const handleConfirm = (e) => {
    e.preventDefault();
    setShow(false);
    deleteFolder(deleteItem);
  };
  const handleRename = (e, item) => {
    e.preventDefault();
    setRename(item);
    setShowRename(true);
    setShowInfo(false);
  };
  const handleRenameConfirm = (e) => {
    e.preventDefault();
    setShowRename(false);
  };
  const handleRenameCallback = (item) => {
    setShowRename(false);
    if (item.id) {
      callbackRename(item.containerId);
    }
  };
  const handleCheckbox = () => setShowCheck(!showCheck);
  const handleMouseLeave = () => {
    showInfo && setShowInfo(false);
  };

  return (
    <>
      <div
        className="Single_DMSFiles"
        onClick={(e) => handleClick(e, folder.id, folder.name, folder.regulationId)}
        onContextMenu={(e) => handleClick(e, folder.id, folder.name, folder.regulationId)}
        onMouseLeave={handleMouseLeave}
      >
        <div className="Single_DMSFiles_inner">
          <div className="Single_DMSFiles_icon">
            <img
              src={
                folder.global
                  ? Admin_folder
                  : folder.companyTemplateDocument
                  ? Share_folder
                  : New_Folder
              }
              alt={
                folder.global
                  ? Admin_folder
                  : folder.companyTemplateDocument
                  ? Share_folder
                  : New_Folder
              }
              onClick={(e) => handleClick(e, folder.id, folder.name)}
              onContextMenu={(e) => handleClick(e, folder.id, folder.name)}
            />
          </div>
          <div className="S-DMSF-Title">{folder.name}</div>
          {showInfo && (
            <div className="S-DMSF_info">
              <ul>
                {/* <li>
                      <a href="#">New Folder</a>
                    </li> */}
                {folder.canEdit && (
                  <li>
                    <Link to="#" onClick={(e) => handleRename(e, folder)}>
                      {t("Rename.label")}
                    </Link>
                  </li>
                )}
                <li>
                  <Link to="#">
                    {t("Information.label")} <BiChevronRight />
                  </Link>
                  <div className="Information_Folder">
                    <p>
                      {t("CreatedOn.label")} :{" "}
                      <b>
                        {" "}
                        {moment(folder.createdDate).format("MMM DD, YYYY")}
                      </b>
                    </p>
                    <p>
                      {t("LastModified.label")} :{" "}
                      <b>
                        {" "}
                        {moment(folder.lastModifiedDate).format("MMM DD, YYYY")}
                      </b>
                    </p>
                    {/* <p>
                        {t("NoofItems.label")} : <b>2</b>
                      </p> */}
                  </div>
                </li>
                {folder.canEdit && (
                  <li>
                    <Link to="#" onClick={(e) => handleDelete(e, folder)}>
                      {t("Delete.label")}
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
      {/* <div className="Single_DMSFiles">
        <div className="Single_DMSFiles_inner">
          <div className="Single_DMSFiles_icon">
            <img src={Admin_folder} alt={Admin_folder} />
          </div>
          <div className="S-DMSF-Title">Admin Folder</div>
        </div>
      </div>

      <div className="Single_DMSFiles">
        <div className="Single_DMSFiles_inner">
          <div className="Single_DMSFiles_icon">
            <img src={Share_folder} alt={Share_folder} />
          </div>
          <div className="S-DMSF-Title">Share folder Name</div>
        </div>
      </div> */}

      {showRename && (
        <FolderCreate
          show={showRename}
          close={handleRenameCallback}
          parentId=""
          item={rename}
        />
      )}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>{t("ConfirmDeleteFolder.label")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Close.label")}
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            {t("Confirm.label")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default withTranslation()(Folder);
